import { render, staticRenderFns } from "./createJoin2.vue?vue&type=template&id=0193485e&scoped=true&"
import script from "./createJoin2.vue?vue&type=script&lang=js&"
export * from "./createJoin2.vue?vue&type=script&lang=js&"
import style0 from "./createJoin2.vue?vue&type=style&index=0&id=0193485e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0193485e",
  null
  
)

export default component.exports